module.exports = __webpack_public_path__ + "static/img/20015 (4).807b5ba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015 (4).webp
// module id = NBwL
// module chunks = 14